import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Building2, Users, WalletCards, UserRound } from 'lucide-react';

const PlatformDashboard = () => {
  const [overview, setOverview] = useState({ tenants: 0, users: 0, customers: 0, accounts: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/platform/overview')
      .then((response) => setOverview(response.data))
      .finally(() => setLoading(false));
  }, []);

  const cards = [
    { label: 'Tenants', value: overview.tenants, icon: Building2 },
    { label: 'Usuários dos tenants', value: overview.users, icon: Users },
    { label: 'Clientes', value: overview.customers, icon: UserRound },
    { label: 'Contas virtuais', value: overview.accounts, icon: WalletCards },
  ];

  return (
    <div className="space-y-8" data-testid="platform-dashboard">
      <div>
        <h1 className="text-4xl font-bold tracking-tight">Gestão da Plataforma</h1>
        <p className="mt-2 text-muted-foreground">Visão global da operação ItechPay</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {cards.map(({ label, value, icon: Icon }) => (
          <Card key={label}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">{label}</CardTitle>
              <Icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold">{loading ? '...' : value}</div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Ambiente Sandbox</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Esta área administra a plataforma inteira. A gestão operacional de clientes, contas e transações continua isolada dentro de cada tenant.
        </CardContent>
      </Card>
    </div>
  );
};

export default PlatformDashboard;
